import type { CoverImage } from '../../../../services/coverImageService';

export const getHeaderImageSrc = (coverImage: CoverImage): string | undefined =>
  coverImage.id ?? coverImage.url;
